import raydiant from '../clients/raydiant';
import { keys } from '../queryClient';
import useProtectedQuery from './useProtectedQuery';

export default function useBillingAccounts() {
  return useProtectedQuery(keys.billingAccounts(), async () => {
    const accounts = await raydiant.getBillingAccounts();
    return [...accounts].sort((a, b) =>
      a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }),
    );
  });
}
